import { render } from "./MisUnidadesMedida.vue?vue&type=template&id=31728d12&scoped=true"
import script from "./MisUnidadesMedida.vue?vue&type=script&lang=js"
export * from "./MisUnidadesMedida.vue?vue&type=script&lang=js"

import "./MisUnidadesMedida.vue?vue&type=style&index=0&id=31728d12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31728d12"]])

export default __exports__